import React from 'react'
import styled, { css } from 'styled-components/macro'
import { FilterFromServer } from '../App'
import { Translate } from '../TranslationsContext'
import { ResultsHeader } from './ResultsHeader'

const Tab = styled.button<{ active: boolean }>`
  position: relative;
  background: none;
  border: none;
  outline: none;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  min-height: 41px;
  padding: 0px 3px;
  margin-right: 16px;
  cursor: pointer;
  transition: color 200ms;
  padding-bottom: 8px;

  white-space: nowrap;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    width: 100%;
    background: transparent;
  }

  ${(p) =>
    p.active
      ? css`
          color: #56a0d3;

          &:after {
            background: #56a0d3;
          }
        `
      : css`
          color: #303030;

          &:hover {
            color: #56a0d3;
          }
        `}
`

type Props = {
  filter: FilterFromServer
  activeFilter: number | undefined
  setActiveFilter: (newActiveFilter: number | undefined) => void
}
export const TabBar: React.FC<Props> = ({ filter, activeFilter, setActiveFilter, children }) => (
  <ResultsHeader>
    <Tab
      active={filter.options.every((option) => option.id !== activeFilter)}
      onClick={() => setActiveFilter(undefined)}
    >
      <Translate id="all" />
    </Tab>

    {filter.options.map((option) => (
      <Tab
        key={option.id}
        active={option.id === activeFilter}
        onClick={() => {
          return setActiveFilter(option.id)
        }}
      >
        {option.name}
      </Tab>
    ))}

    <div style={{ flex: '1 1 100%' }}></div>

    {children}
  </ResultsHeader>
)
